<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="showDelModal=false;deleteUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
             <Select v-model="status" style="width:200px">
                     <Option value="" >{{$t('pleaseSelect')}}</Option>
                    <Option value="1" >{{$t('agent.status1')}}</Option>
                    <Option value="0">{{$t('agent.status0')}}</Option>
                    <Option value="2">{{$t('agent.status2')}}</Option>
             </Select>

            <DatePicker v-model="start" type="date" :placeholder="$t('select')+$t('date')" style="width: 200px"></DatePicker>
            ---
            <DatePicker v-model="end"  type="date" :placeholder="$t('select')+$t('date')" style="width: 200px"></DatePicker>

            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="btnAdd()">{{$t('add')}}{{$t('agent.agent')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
            <template slot-scope="{ row }" slot="status">
                <Tag color="green" v-if="row.status==1">{{$t('agent.status1')}}</Tag>
                <Tag color="red" v-else-if="row.status==0">{{$t('agent.status0')}}</Tag>
                <Tag color="gold" v-else-if="row.status==2">{{$t('agent.status2')}}</Tag>
            </template>
            <template slot-scope="{ row }" slot="action">
                <Button type="success" size="small" style="margin-right: 5px" @click="editDetail(row.id)">{{$t('edit')}}</Button>
                <Button type="error" size="small" style="margin-right: 5px" @click="delAgent(row.id)">{{$t('del')}}</Button>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_add_user" :title="$t('agent.agent')" @on-ok="add_user">
            <Form :model="modalAdd" ref="detail" :label-width="100">
                <input type="hidden" name="id" v-model="modalAdd.id">
                <Form :model="modalAdd" :label-width="100">
                    <FormItem :label="$t('username')">
                        <Input v-model="modalAdd.username"></Input>
                    </FormItem>
                    <FormItem :label="$t('password')">
                        <Input type="password" v-model="modalAdd.password" :placeholder="$t('passwordTips')"></Input>
                    </FormItem>
                </Form>

                <FormItem :label="$t('status')">
                    <Select v-model="modalAdd.status">
                        <Option value="1" >{{$t('agent.status1')}}</Option>
                        <Option value="0">{{$t('agent.status0')}}</Option>
                        <Option value="2">{{$t('agent.status2')}}</Option>
                    </Select>
                </FormItem>

                <FormItem :label="$t('agent.serviceLink')">
                    <Input  v-model="modalAdd.service_link"></Input>
                </FormItem>
                <FormItem :label="$t('agent.codeLimitToday')">
                    <Input  v-model="modalAdd.code_limit_today"></Input>
                </FormItem>
                <FormItem :label="$t('agent.ipWhite')">
                    <Input  v-model="modalAdd.ip_white"  :placeholder="$t('agent.ipWhiteTips')"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>


<script>
export default {
    data() {
        return {
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            search: "",
            start:new Date(),
            end:new Date(),
            status:"",
            columns12: [
                {
                    title: "ID",
                    key: "id"
                },
                {
                    title: this.$i18n.t('agent.agentAccout'),
                    key: "username"
                },
                  {
                    title: this.$i18n.t('agent.codeLimitToday'),
                    key: "code_limit_today"
                },
                {
                    title:this.$i18n.t('agent.userToday'),
                    key:"user_count"
                },               
                {
                    title:this.$i18n.t('agent.orderToday'),
                    key:"order_count"
                },
                {
                    title: this.$i18n.t('status'),
                    key: "status",
                    slot:"status"
                },
                {
                    title: this.$i18n.t('agent.serviceLink'),
                    key: "service_link",
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 380,
                    align: "center"
                }
            ],
            data6: [],
            modalAdd: {
                id:0,
                username: "",
                password: "",
                service_link:"#",
                code_limit_today:"0",
                ip_white:"",
                status:"1"
            },
            modalEdit:{
                user_id:'',
                pass:''
            },
            show_add_user: false,
            show_edit_pass:false
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let path = this.search ? this.$path.user_search : this.$path.agent;
            this.$get(path, {
                mobile: this.search,
                start:this.start ? this.start.toLocaleDateString('chinese') : '',
                end:this.end? this.end.toLocaleDateString('chinese') : '',
                status:this.status,
                page: this.currentPage
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    const that=this;

                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        delAgent(id) {
            if(!confirm(this.$i18n.t('confirm')+this.$i18n.t('del'))){
                return false;
            }
            this.$post(this.$path.agent_del, {
                id: id
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(user_id) {
            this.userIdToDel = user_id;
            this.showDelModal = true;
        },
        add_user() {
            this.$post(this.$path.agent_add, this.modalAdd).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalAdd = {
                        id:0,
                        username: "",
                        password: "",
                        service_link:"#",
                        code_limit_today:"0",
                        ip_white:"",
                        status:1
                    }
                }
            });
        },
        btnAdd(){
            this.modalAdd = {
                id:0,
                username: "",
                password: "",
                service_link:"#",
                code_limit_today:"0",
                ip_white:"",
                status:1
            }
                this.show_add_user = true;
        },
        editDetail(id){
            this.$get(this.$path.agent_detail,{"id":id}).then(res=>{
                if(res.success){
                    res.data.status = String(res.data.status);
                    res.data.password ='';
                    this.modalAdd = res.data;
                    this.show_add_user = true;
                }else{
                    console.log(res.$Message);
                }
            });
        },
        click_edit_pass(user_id){
            this.modalEdit.user_id = user_id;
            this.show_edit_pass = true;
        },
        change_vip_level(user_id,vip_level){
            this.$post(this.$path.change_vip_level, {user_id:user_id,vip_level:vip_level}).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        edit_pass(){
            this.$post(this.$path.restpass, this.modalEdit).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.modalEdit.pass = '';
                }
            });
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/agent/agent.vue